import { render } from "./VendorListDivider.vue?vue&type=template&id=4f890b72&scoped=true&ts=true"
import script from "./VendorListDivider.vue?vue&type=script&lang=ts"
export * from "./VendorListDivider.vue?vue&type=script&lang=ts"

import "./VendorListDivider.vue?vue&type=style&index=0&id=4f890b72&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f890b72"]])

export default __exports__